import c0 from './annotations_controller';
import c1 from './autocomplete_controller';
import c2 from './browser_extension_controller';
import c3 from './clipboard_controller';
import c4 from './dialog_controller';
import c5 from './dropzone_controller';
import c6 from './history_controller';
import c7 from './inplace_input_controller';
import c8 from './login_form_controller';
import c9 from './menu_controller';
import c10 from './modal_images_controller';
import c11 from './modal_videos_controller';
import c12 from './panel_controller';
import c13 from './pass_reveal_controller';
import c14 from './remote_controller';
import c15 from './remover_controller';
import c16 from './request_controller';
import c17 from './scroll_progress_controller';
import c18 from './scroll_tracker_controller';
import c19 from './scrollto_controller';
import c20 from './styler_controller';
import c21 from './tabs_controller';
import c22 from './theme_controller';
import c23 from './timetoken_controller';
import c24 from './turbo_form_controller';
import c25 from './turbo_refresh_controller';
import c26 from './turbo_reload_controller';
import c27 from './video_controller';
export const definitions = [
	{identifier: 'annotations', controllerConstructor: c0},
	{identifier: 'autocomplete', controllerConstructor: c1},
	{identifier: 'browser-extension', controllerConstructor: c2},
	{identifier: 'clipboard', controllerConstructor: c3},
	{identifier: 'dialog', controllerConstructor: c4},
	{identifier: 'dropzone', controllerConstructor: c5},
	{identifier: 'history', controllerConstructor: c6},
	{identifier: 'inplace-input', controllerConstructor: c7},
	{identifier: 'login-form', controllerConstructor: c8},
	{identifier: 'menu', controllerConstructor: c9},
	{identifier: 'modal-images', controllerConstructor: c10},
	{identifier: 'modal-videos', controllerConstructor: c11},
	{identifier: 'panel', controllerConstructor: c12},
	{identifier: 'pass-reveal', controllerConstructor: c13},
	{identifier: 'remote', controllerConstructor: c14},
	{identifier: 'remover', controllerConstructor: c15},
	{identifier: 'request', controllerConstructor: c16},
	{identifier: 'scroll-progress', controllerConstructor: c17},
	{identifier: 'scroll-tracker', controllerConstructor: c18},
	{identifier: 'scrollto', controllerConstructor: c19},
	{identifier: 'styler', controllerConstructor: c20},
	{identifier: 'tabs', controllerConstructor: c21},
	{identifier: 'theme', controllerConstructor: c22},
	{identifier: 'timetoken', controllerConstructor: c23},
	{identifier: 'turbo-form', controllerConstructor: c24},
	{identifier: 'turbo-refresh', controllerConstructor: c25},
	{identifier: 'turbo-reload', controllerConstructor: c26},
	{identifier: 'video', controllerConstructor: c27},
];
